import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { API } from "@/lib/api";
import { ADMIN_TOKEN_KEY } from "@/lib/constants";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthCallback() {
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : "";
    if (!sessionId) { setError("Keine Sitzung gefunden."); return; }
    axios.post(`${API}/auth/google/session`, { session_id: sessionId })
      .then((r) => {
        localStorage.setItem(ADMIN_TOKEN_KEY, r.data.token);
        window.location.replace("/app");
      })
      .catch((e) => {
        setError(e.response?.data?.detail || "Google-Anmeldung fehlgeschlagen.");
      });
  }, []);

  return (
    <div className="min-h-screen bg-[var(--brand-bg)] flex items-center justify-center p-4 font-[Inter]">
      <Card className="w-full max-w-md p-8 border-[var(--brand-border)] text-center" data-testid="google-callback">
        {error ? (
          <>
            <p className="text-sm text-red-600 mb-4" data-testid="google-callback-error">{error}</p>
            <a href="/app" className="text-sm text-[var(--brand-primary)] hover:underline" data-testid="google-callback-back">Zur Anmeldung</a>
          </>
        ) : (
          <p className="text-sm text-[var(--brand-muted)]">Google-Anmeldung wird abgeschlossen …</p>
        )}
      </Card>
    </div>
  );
}
